// removed by extract-text-webpack-plugin
module.exports = {"PriceInput":"PriceInput","OrderTypes":"OrderTypes","Show":"Show","Top":"Top","OrderTypesItem":"OrderTypesItem","OrderTypeText":"OrderTypeText","OrderTypeComponent":"OrderTypeComponent","PaddingT":"PaddingT","OrderTypeTextCenter":"OrderTypeTextCenter","SelectedItem":"SelectedItem","TooltipBox":"TooltipBox","tooltip-inner":"tooltip-inner","arrow":"arrow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/PriceInput/styles.scss
// module id = 2162
// module chunks = 10